import { useHistoryStore } from '@/stores/router/useHistoryStore'
import { Route } from 'vue-router'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { checkNoRequiresAuthURL } from '../helpers/routes'

export const historyGuard = (to: Route, _from: Route, next: () => void): void => {
  const isMobileUser = store.getters[`${ModuleNamespaces.AUTH}/getIsMobileUser`]
  if (isMobileUser) {
    return next()
  }
  try {
    const { name } = to
    const noSaveInHistory = checkNoRequiresAuthURL(name ?? '')
    if (!noSaveInHistory) {
      const store = useHistoryStore()
      store.addHistory(to)
    }
  } catch (error) {
    console.log({ error })
  }
  return next()
}
